// extracted by mini-css-extract-plugin
export default {"container":"FeatureTermsList_container__bwXhV","spacer":"FeatureTermsList_spacer__muo+3"};